<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M12.75 3.94C13.75 3.22 14.91 2.86 16.22 2.86C16.94 2.86 17.73 3.05 18.59 3.45C19.45 3.84 20.13 4.3 20.63 4.83C21.66 6.11 22.09 7.6 21.94 9.3C21.78 11 21.22 12.33 20.25 13.27L12.66 20.86C12.47 21.05 12.23 21.14 11.95 21.14C11.67 21.14 11.44 21.05 11.25 20.86C11.06 20.67 10.97 20.44 10.97 20.16C10.97 19.88 11.06 19.64 11.25 19.45L15.84 14.86C16.09 14.64 16.09 14.41 15.84 14.16C15.59 13.91 15.36 13.91 15.14 14.16L10.55 18.75C10.36 18.94 10.13 19.03 9.84005 19.03C9.56005 19.03 9.33005 18.94 9.14005 18.75C8.95005 18.56 8.86005 18.33 8.86005 18.05C8.86005 17.77 8.95005 17.53 9.14005 17.34L13.73 12.75C14 12.5 14 12.25 13.73 12C13.5 11.75 13.28 11.75 13.03 12L8.44005 16.64C8.25005 16.83 8.00005 16.92 7.73005 16.92C7.45005 16.92 7.21005 16.83 7.00005 16.64C6.80005 16.45 6.70005 16.22 6.70005 15.94C6.70005 15.66 6.81005 15.41 7.03005 15.19L11.63 10.59C11.88 10.34 11.88 10.11 11.63 9.89C11.38 9.67 11.14 9.67 10.92 9.89L6.28005 14.5C6.06005 14.7 5.83005 14.81 5.58005 14.81C5.30005 14.81 5.06005 14.71 4.88005 14.5C4.69005 14.3 4.59005 14.06 4.59005 13.78C4.59005 13.5 4.69005 13.27 4.88005 13.08C7.94005 10 9.83005 8.14 10.55 7.45L14.11 10.97C14.5 11.34 14.95 11.53 15.5 11.53C16.2 11.53 16.75 11.25 17.16 10.69C17.44 10.28 17.54 9.83 17.46 9.33C17.38 8.83 17.17 8.41 16.83 8.06L12.75 3.94ZM14.81 10.27L10.55 6L3.47005 13.08C2.63005 12.23 2.15005 10.93 2.04005 9.16C1.93005 7.4 2.41005 5.87 3.47005 4.59C4.66005 3.41 6.08005 2.81 7.73005 2.81C9.39005 2.81 10.8 3.41 11.95 4.59L16.22 8.86C16.41 9.05 16.5 9.28 16.5 9.56C16.5 9.84 16.41 10.08 16.22 10.27C16.03 10.45 15.8 10.55 15.5 10.55C15.23 10.55 15 10.45 14.81 10.27Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "PlanoCuidadoIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
